import { combineEpics } from 'redux-observable';
import { epics as authEpics } from '@src/app/login/epics';
import { epics as accountEpics } from '@src/app/accounts/redux/epics';
import { epics as notifications } from '@src/app/notifications/epics';
import { epics as intelliselEpics } from '@src/app/intellisel/epics';
import { epics as cognitoEpics } from '@src/app/login/cognito/epics';
import { epics as eventLoggingEpics } from '@src/app/eventLogging/epics';

export const rootEpic = combineEpics(
  authEpics,
  accountEpics,
  notifications,
  cognitoEpics,
  intelliselEpics,
  eventLoggingEpics
);
